export enum SessionGoalType {
    Screenshot = 'screenshot',
    AsyncRequest = 'async-request'
}
